<template>
  <div style="border: 1px solid #ccc;width:80%">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor style="height: 300px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" />
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/common/apis'
import { Editor, Toolbar  } from '@wangeditor/editor-for-vue'

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
        excludeKeys: [
    'insertImage',  // 移除网络图片
    'insertVideo',  // 移除网络视频
  ]
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {

            // 使用自定义图片上传
            customUpload(file, insertFn) {
              // 这里返回 true，表示自定义上传处理，阻止默认上传流程
              return true
            },
            // 自定义选择图片并上传
            customBrowseAndUpload(insertFn) {

              // 创建文件选择器
              const input = document.createElement('input')
              input.type = 'file'
              input.accept = 'image/*'
              input.multiple = true

              // 监听文件选择事件
              input.addEventListener('change', (e) => {
                const files = e.target.files
                if (!files || !files.length) return

                // 处理选中的文件
                Array.from(files).forEach(file => {
                  // 可以在此处添加文件类型、大小检查
                  if (!file.type.includes('image/')) {
                    alert('请选择图片文件')
                    return
                  }

                  if (file.size > 5 * 1024 * 1024) {
                    alert('图片大小不能超过5MB')
                    return
                  }

                  // 方法一：使用FormData上传到服务器
                  // const formData = new FormData()
                  // formData.append('image', file)

                  // 使用axios或Vue资源上传
                  api.upload({
                    file: file
                  }).then(res => {
                    if (res.code === 1) {
                      insertFn(res.data.fullurl, file.name, '')
                    } else {
                      alert('上传失败: ' + (res.message || res.msg || '未知错误'))
                    }
                  }).catch(err => {
                    console.error('上传出错', err)
                    alert('上传出错，请重试')
                  })


                })
              })

              // 触发文件选择窗口
              input.click()
            }
          },
          uploadVideo: {
            customUpload(file, insertFn) {
              return true
            },
            customBrowseAndUpload(insertFn) {

              // 创建文件选择器
              const input = document.createElement('input')
              input.type = 'file'
              input.accept = 'video/*'
              input.multiple = true

              // 监听文件选择事件
              input.addEventListener('change', (e) => {
                const files = e.target.files
                if (!files || !files.length) return

                // 处理选中的文件
                Array.from(files).forEach(file => {
                  // 可以在此处添加文件类型、大小检查
                  if (!file.type.includes('video/')) {
                    alert('请选择视频文件')
                    return
                  }

                

                  // 方法一：使用FormData上传到服务器
                  // const formData = new FormData()
                  // formData.append('image', file)

                  // 使用axios或Vue资源上传
                  api.upload({
                    file: file
                  }).then(res => {
                    if (res.code === 1) {
                      insertFn(res.data.fullurl, file.name, '')
                    } else {
                      alert('上传失败: ' + (res.message || res.msg || '未知错误'))
                    }
                  }).catch(err => {
                    console.error('上传出错', err)
                    alert('上传出错，请重试')
                  })


                })
              })

              // 触发文件选择窗口
              input.click()
            }
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.html = newVal
      },
      immediate: true
    },
    html: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      immediate: true
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错

    },
  },
  mounted() {
 
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
})
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.w-e-full-screen-container{
  z-index: 99999;
}
</style>
